import React, { useState, useRef } from "react";
import CodeExecutor2 from "../../../../components/CodeExecutor/CodeExecutor2.js";

import {
  Card,
  Row,
  Col,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  CardFooter,
  Container
} from "reactstrap";
import LessonNavBar from "components/Navbars/LessonNavBar.js";

import { CheckCode } from "./CheckCode.js";

import classnames from "classnames";
import MainFooter from "../../../../components/Footers/MainFooter.js";
import { useLesson } from "../../../../hooks/lessonFramework.js";
import { useUserAuth } from "../../../../context/UserContext.js";
import NavigationButton from "../../../../components/NavigationButton/NavigationButton.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardUser, faSquareCheck, faRobot } from "@fortawesome/free-solid-svg-icons";

import Highlight, { defaultProps } from "prism-react-renderer";
import github from "prism-react-renderer/themes/github";

import AIAssistant from "pages/AI/AIAssistant.js";
import { CODESNIPPET } from "../../../../constants/codeSnippet.js";

const SyntaxComponent = () => {
  const lessonID = "JA101";
  const { lessonCode, setInitialCode } = useLesson();
  const mainRef = useRef(null);
  const { user } = useUserAuth();
  const [activeTab, setActiveTab] = useState("1");


  const codeSnippet = `public class Main
                
  {
      public static void main(String[] args) {
          System.out.println("Welcome to Online IDE!! Happy Coding :)");
      }
  }`;




  const executeTests = (code, output) => {
    const newCheckedStates = CheckCode(code, output, checkedStates, user, lessonID);
    updateCheckboxState(newCheckedStates);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // CHECKBOXS
  const [checkedStates, setCheckedStates] = useState({
    checkbox1: false,

  });

  // Function to update the state of specific checkboxes
  const updateCheckboxState = (updates) => {
    setCheckedStates((prevState) => ({
      ...prevState,
      ...updates, // Merge the updates into the current state
    }));
  };
  // CHECKBOXS


  return (
    <>
      <div className=" lessonBackgroundColor1 lessonMain  h-100vh" >
        <LessonNavBar />
        <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
          <section>
            <Container fluid className=" pr-0 pl-0   fullWitdthHeight ">
              <CodeExecutor2 languageCode="java" initialCode={lessonCode} runTestCase={executeTests}>
                <Card className="fullWitdthHeight">
                  <CardHeader className=" lesson-header">Syntax</CardHeader>
                  <TabContent className="fullWitdthHeight overflow-auto " activeTab={activeTab}>
                    <TabPane className="fullWitdthHeight " tabId="1">
                      <CardBody>
                        <CardTitle tag="h5">
                          What Is Syntax?
                        </CardTitle>
                        <CardText>
                          Syntax refers to the set of rules that defines how to write code in a programming language. Just like grammar in a language, Java’s syntax ensures that the computer can understand and execute the code you write.
                        </CardText>

                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.BasicStructureCode1} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          This line of code follows Java’s syntax rules to print a message to the screen.
                        </CardText>

                        <CardText>
                          If you forget a semicolon or type a keyword incorrectly, your program will not work.
                        </CardText>

                      </CardBody>
                    </TabPane>

                    <TabPane tabId="2">
                      <CardBody>
                        {/* CHECKBOXS */}
                        <h4>Try It Yourself</h4>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox1"
                                checked={checkedStates.checkbox1}
                                readOnly
                              />
                              1. Modify the program so that it prints "Welcome to Java Programming!". In other words, replace "Hello, World!" with "Welcome to Java Programming!".
                            </Label>
                          </FormGroup>
                        </div>
                        {/* CHECKBOXS */}
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="3">
                      <CardBody>
                        <AIAssistant></AIAssistant>
                      </CardBody>
                    </TabPane>
                  </TabContent>
                  <CardFooter className=" lesson-footer">
                    <Nav tabs className="justify-content-center my-nav-tabs ">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => toggle("1")}
                        >
                          <FontAwesomeIcon icon={faChalkboardUser} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => toggle("2")}
                        >
                          <FontAwesomeIcon icon={faSquareCheck} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "3" })}
                          onClick={() => toggle("3")}
                        >
                          <FontAwesomeIcon icon={faRobot} size="lg" />
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </CardFooter>
                </Card>
              </CodeExecutor2>
            </Container>
          </section>
          <section >
            <Container className="container-lg">
              <Row className=" p-3   align-items-center  justify-content-between">
                <NavigationButton direction="back" ></NavigationButton>
                <p>1/10</p>
                <NavigationButton direction="next" page="basicStructure"></NavigationButton>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
};

export default SyntaxComponent;
